import {
  convertValueForStorage,
  convertValueFromStorage,
  getCustomFieldType,
} from 'components/admin/inventory/mapping/customFieldUtils';

const getCustomFieldUnit = (type, format) => {
  if (type === 'volume' || type === 'mass') {
    return format;
  }

  if (type === 'list') {
    return 'enum';
  }

  return '';
};

const getStoredFieldValue = (itemData, csvName, fieldConfig) => {
  const storedValue = itemData[csvName];
  const { type, format } = getCustomFieldType(fieldConfig);
  let displayValue;
  if (type === 'date') {
    displayValue = storedValue;
  } else if (type === 'boolean') {
    displayValue = convertValueForStorage(storedValue, type, format);
  } else {
    displayValue = convertValueFromStorage(storedValue, type, format);
  }

  return {
    value: displayValue ?? '',
    unit: getCustomFieldUnit(type, format),
  };
};

export const buildCustomOperatorFieldDefaults = ({
  itemData,
  columnMappings,
  customOperatorFields = [],
}) => customOperatorFields.reduce((acc, fieldId) => {
  const fieldConfig = columnMappings?.[fieldId];
  const csvName = fieldConfig?.mapping?.csvName;

  if (!csvName) {
    return acc;
  }

  acc[fieldId] = getStoredFieldValue(itemData, csvName, fieldConfig);
  return acc;
}, {});
